import { z } from 'zod';
import { SalesOrderItemType } from '../../constants/sales-order-item-type.js';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
import { SALES_ORDER_LINE_CONSTRAINTS } from './constraints.js';
import { salesOrderLineNoteSchema } from './item-note.js';
import { salesOrderLineQuantitySchema } from './item-quantity.js';
import { salesOrderLineUnitPriceSchema } from './item-unit-price.js';
import { ZERO_REVENUE_LINE_TYPES } from './zero-revenue-line-types.js';
export const addSalesOrderItemInputSchema = z
    .object({
    salesOrderId: requiredUuidString(`${SALES_ORDER_LINE_CONSTRAINTS.salesOrder.label} is required.`, 'Invalid sales order selection.'),
    productId: requiredUuidString(`${SALES_ORDER_LINE_CONSTRAINTS.product.label} is required.`, 'Invalid product selection.'),
    qty: salesOrderLineQuantitySchema,
    unitPrice: salesOrderLineUnitPriceSchema,
    // Omitted means Sale, matching addSalesOrderItem's existing default.
    typeId: z
        .enum(SalesOrderItemType, `Invalid ${SALES_ORDER_LINE_CONSTRAINTS.lineType.label.toLowerCase()}.`)
        .optional(),
    uomId: optionalUuidString(`Invalid ${SALES_ORDER_LINE_CONSTRAINTS.uom.label.toLowerCase()} selection.`)
        .optional()
        .nullable(),
    note: salesOrderLineNoteSchema,
})
    .superRefine((values, context) => {
    if (values.typeId != null &&
        ZERO_REVENUE_LINE_TYPES.has(values.typeId) &&
        values.unitPrice !== 0) {
        context.addIssue({
            code: 'custom',
            message: 'Sample and Promo lines must be booked at zero unit price.',
            path: ['unitPrice'],
        });
    }
});
//# sourceMappingURL=add-item-input.js.map